if (!customElements.get('style-gallery-masonry-pdp')) {
  customElements.define(
    'style-gallery-masonry-pdp',
    class StyleGalleryMasonryPdp extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.grid = this.querySelector('.sgm-grid');
        if (!this.grid) return;
        this.sync = this.sync.bind(this);
        this.sync();
        // Keep the implicit row height equal to a column's width * (485/380) so a 2x2
        // feature tile stays the same aspect as a 1x1 tile (no cropping). Recompute on
        // any container width change.
        if (typeof ResizeObserver !== 'undefined') {
          this.ro = new ResizeObserver(this.sync);
          this.ro.observe(this.grid);
        } else {
          window.addEventListener('resize', this.sync);
        }
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        window.removeEventListener('resize', this.sync);
      }

      sync() {
        const cs = getComputedStyle(this.grid);
        if (cs.display !== 'grid') return; // single-image fallback uses block layout
        const cols = cs.gridTemplateColumns.split(' ').filter(Boolean).length || 1;
        const gap = parseFloat(cs.columnGap) || 0;
        const colWidth = (this.grid.clientWidth - gap * (cols - 1)) / cols;
        if (colWidth > 0) {
          this.grid.style.setProperty('--sgm-row', `${colWidth * (485 / 380)}px`);
        }
      }
    }
  );
}
